import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaPlayer = ({ formikRef, grupoMaterialId = 0, permitir = 0, showAll = true }) => {
  const pesquisaPlayerSelect = useSelect("pesquisaPlayers");
  const [pesquisaPlayer, setPesquisaPlayer] = useState(0);
  const [pesquisaPlayerObjeto, setPesquisaPlayerObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaPlayers, setPesquisaPlayers] = useState(undefined);
  const [pesquisaGrupoMaterialPlayer, setPesquisaGrupoMaterialPlayer] = useState([]);

  const fetchPesquisaPlayers = async () => {
    const players = [];
    await db.pesquisaPlayers.each((player) => {
      if (showAll || player.ativo || permitir == player.id) players.push(player);
    });
    setPesquisaPlayers(players);
  };

  const fetchPesquisaGrupoMaterialPlayer = async () => {
    const grupoMaterialPlayers = [];
    await db.pesquisaGrupoMaterialPlayer.each((grupo) => {
      grupoMaterialPlayers.push(grupo);
    });
    setPesquisaGrupoMaterialPlayer(grupoMaterialPlayers);
  };

  useEffect(() => {
    fetchPesquisaPlayers();
    fetchPesquisaGrupoMaterialPlayer();
  }, []);

  useEffect(() => {
    fetchPesquisaPlayers();
    fetchPesquisaGrupoMaterialPlayer();
  }, [permitir]);

  const availablePlayers = useMemo(() => {
    if (pesquisaPlayers?.length > 0) {
      return pesquisaPlayers.reduce((acc, cur) => {
        if (
          !cur.nome.includes("CLIENTE NÃO CONSOME") &&
          !["CLIENTE FECHADO", "CLIENTE NÃO CONSOME PROD. BÁSICOS"].includes(cur.nome)
        ) {
          acc[cur.id] = true;
        }
        return acc;
      }, {});
    }

    return {};
  }, [pesquisaPlayers]);

  //OPTIONS
  const pesquisaGrupoMaterialPlayers = useMemo(() => {
    if (pesquisaGrupoMaterialPlayer && pesquisaGrupoMaterialPlayer.length > 0) {
      return pesquisaGrupoMaterialPlayer.reduce((acc, e) => {
        acc[e.pesquisaGrupoMaterialId + "/" + e.pesquisaPlayerId] = true;
        return acc;
      }, {});
    } else {
      return {};
    }
  }, [pesquisaGrupoMaterialPlayer]);

  useEffect(() => {
    if (grupoMaterialId && grupoMaterialId != 0) {
      const exists = (pesquisaPlayers || []).find(
        (e) => e.id == pesquisaPlayer && pesquisaGrupoMaterialPlayers[grupoMaterialId + "/" + e.id]
      );
      if (!exists) {
        onChangePesquisaPlayer({
          value: null,
        });
      }
    }
  }, [grupoMaterialId, pesquisaPlayers]);

  const optionPesquisaPlayer = useMemo(() => {
    let temp = [];
    if (grupoMaterialId && grupoMaterialId != 0) {
      temp = (pesquisaPlayers || []).filter(
        (e) =>
          e.ativo &&
          Object.entries(pesquisaGrupoMaterialPlayers).length > 0 &&
          pesquisaGrupoMaterialPlayers[grupoMaterialId + "/" + e.id]
      );
    }

    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaPlayers, pesquisaGrupoMaterialPlayers, grupoMaterialId]);

  useEffect(() => {
    if (
      fila &&
      pesquisaPlayers?.length > 0 &&
      pesquisaGrupoMaterialPlayers &&
      Object.keys(pesquisaGrupoMaterialPlayers).length > 0
    ) {
      setPesquisaPlayerSelect(fila);
    }

    if (pesquisaPlayers?.length > 0) {
      setPesquisaPlayerObjeto(getColumnIntoKey({ data: pesquisaPlayers, prefix: "id-" }));
    }
  }, [fila, pesquisaPlayers, pesquisaGrupoMaterialPlayers]);

  function setPesquisaPlayerSelect(value) {
    if (
      pesquisaPlayers?.length > 0 &&
      pesquisaGrupoMaterialPlayers &&
      Object.keys(pesquisaGrupoMaterialPlayers).length > 0
    ) {
      const optionPlayer = (pesquisaPlayers || []).find((optPlayer) => optPlayer.id == value);

      if (optionPlayer) {
        onChangePesquisaPlayer({
          label: optionPlayer.nome,
          value: optionPlayer.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaPlayer(e) {
    pesquisaPlayerSelect.upDateValue(e.value);
    pesquisaPlayerSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("empresaId", e.value);
      e.value && setTimeout(() => formikInstance.setFieldTouched("empresaId", true));
    }
    setPesquisaPlayer(e?.value);
  }

  return {
    availablePlayers,
    pesquisaPlayerObjeto,
    pesquisaPlayer,
    optionPesquisaPlayer,
    onChangePesquisaPlayer,
    pesquisaPlayers,
    pesquisaPlayerSelect,
    setPesquisaPlayer,
    setPesquisaPlayerSelect,
  };
};

export default usePesquisaPlayer;
